<script setup lang="ts">
import type {InputField} from "~/constants/types/serviceInputs";

const props = defineProps<{
  field: InputField
}>();
if (!props.field.option){
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
}
const handleSelect = (id: string,option:any) => {
  if (disableRepetitions.value && option.key !== 'one_time')
    return
  props.field.default_value = id;
  props.field.option=option?.option;
};
watch(useStoreSelectedServiceId(),()=>{
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
},{immediate:true})
const selected = computed(() => props.field.default_value);

const {t} = useI18n()
const repeatedDiscounts = ['15', '10', '5']
const optionDescription = (option: any) => {
  if (option.key === 'one_time') {
    return t('order_page.no_discount')
  }
  const repeatedOptions = props.field.options.filter((o) => o.key !== 'one_time')
  const index = repeatedOptions.findIndex((o) => o.option_id === option.option_id)
  return index > -1 && repeatedDiscounts[index]
      ? t('order_page.discount_percent', {percent: repeatedDiscounts[index]})
      : option.description
}

const route = useRoute()
const isBccPage = computed(() => route.name === 'bcc')

const promoCode = useStorePromoCode()
const disableRepetitions = ref(false)
const oneTime = computed(() => props.field.options.find((option)=>option.key === 'one_time'))
watch(promoCode, (val) => {
  if (val.length) {
    disableRepetitions.value = true
    handleSelect(oneTime.value?.option_id, oneTime.value)
  } else {
    disableRepetitions.value = false
  }
}, {immediate: true})
</script>

<template>
  <div class="form_block px-0">
    <div class="flex justify-between md:gap-3 gap-2 md:items-center items-start md:flex-row flex-col md:px-5 px-2">
      <p class="text-sm md:text-base font-bold">{{ $t('order_page.titles.cleaning_frequency') }}</p>
      <p v-if="!isBccPage" class="md:text-sm text-xs text-secondary-800">{{ $t('order.promo_code.valid_on_one') }}</p>
<!--      <p class="text-sm text-primary-green font-medium">Как это работает?</p>-->
    </div>

    <div class="grid grid-cols-2 gap-2 mb-[10px] md:px-5 px-2">
      <button
          v-for="option in field.options"
          :key="option.option_id"
          type="button"
          @click="handleSelect(option.option_id,option)"
          class="flex flex-col items-start gap-[3px] py-[11px] px-[14px] rounded-[14px] text-left border-[1.5px]"
          :class="[
            selected == option.option_id
              ? 'border-primary-green bg-primary-green bg-opacity-[0.08]'
              : 'border-[#E8EAE8] bg-white',
            disableRepetitions && option.key !== 'one_time' ? 'opacity-50 cursor-default' : ''
          ]"
      >
        <span
            class="text-[13px] md:text-base"
            :class="selected == option.option_id ? 'font-bold text-primary-green' : 'font-semibold text-[#16211C]'"
        >{{ option.option }}</span>
        <span
            v-if="optionDescription(option)"
            class="text-[11px] md:text-sm"
            :class="option.key === 'one_time' ? 'font-medium text-[#B6BDB8]' : 'font-bold text-primary-green'"
        >{{ optionDescription(option) }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>